(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('PracticeProfileDetailController', PracticeProfileDetailController);

    PracticeProfileDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PracticeProfile'];

    function PracticeProfileDetailController($scope, $rootScope, $stateParams, previousState, entity, PracticeProfile) {
        var vm = this;

        vm.practiceProfile = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('getwellApp:practiceProfileUpdate', function(event, result) {
            vm.practiceProfile = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
